import { render, staticRenderFns } from "./DatoAdicional.vue?vue&type=template&id=e75a332c&"
import script from "./DatoAdicional.vue?vue&type=script&lang=js&"
export * from "./DatoAdicional.vue?vue&type=script&lang=js&"
import style0 from "./DatoAdicional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports